import React from "react";

const Navber3 = () => {
  return (
    <div className="bg-gradient-to-r from-blue-900 via-blue-700 to-blue-500 auto-h-screen">
      <section className="py-8 px-4 dark:bg-blue-800" id="education">
        <br></br>
        <br></br>
        <h2 className="text-3xl font-bold text-blue-200 dark:text-white mb-4">
          Education Qualifications :-
        </h2>
        <ul className="space-y-4">
          <li className="bg-blue-200 rounded-lg p-4 bg-blue-300 hover:bg-blue-400 transition duration-300 transfrom flex flex-col md:flex-row md:items-center">
            <div className="flex-grow">
              <a href="https://itmuniversity.ac.in/">
                <h3 className="text-xl font-bold text-blue-900 dark:text-white">
                  Master of Computer Applications - (Post Graduation)
                </h3>
                <div className="text-blue-700 dark:text-blue-400 text-1xl">
                  Course Type: <b>Full-time on Campus</b>
                </div>
                <div className="text-blue-700 dark:text-blue-400 text-1xl">
                  University Name: <b>ITM University, Gwalior</b>
                  <br />
                  Address: <b>Madhya Pradesh, India. Pin code: 474001</b>
                  <br />
                  Duration: <b>(2017-2020)</b>
                </div>
              </a>
            </div>
            <div className="flex-shrink-0">
              <a href="https://itmuniversity.ac.in/">
                <img
                  src="https://image3.mouthshut.com/images/imagesp/925081582s.png"
                  className="w-42 h-24 rounded-lg  bg-blue-200"
                  alt="Master of Computer Applications"
                />
              </a>
            </div>
          </li>
          <li className="bg-blue-200 rounded-lg p-4 bg-blue-300 hover:bg-blue-400 transition duration-300 flex flex-col md:flex-row md:items-center">
            <div className="flex-grow">
              <a href="https://itmuniversity.ac.in/">
                <h3 className="text-xl font-bold text-blue-900 dark:text-white">
                  Bachelor of Computer Applications - (Graduation)
                </h3>
                <div className="text-blue-700 dark:text-blue-400 text-1xl">
                  Course Type: <b>Full-time on Campus</b>
                </div>
                <div className="text-blue-700 dark:text-blue-400 text-1xl">
                  University Name: <b>ITM University, Gwalior</b>
                  <br />
                  Address: <b>Madhya Pradesh, India. Pin code: 474001</b>
                  <br />
                  Duration: <b>(2014-2017)</b>
                </div>
              </a>
            </div>
            <div className="flex-shrink-0">
              <a href="https://itmuniversity.ac.in/">
                <img
                  src="https://image3.mouthshut.com/images/imagesp/925081582s.png"
                  className="w-42 h-24 rounded-lg  bg-blue-200"
                  alt="Bachelor of Computer Applications"
                />
              </a>
            </div>
          </li>
          <li className="bg-blue-300 rounded-lg p-4 hover:bg-blue-400 transition duration-300 flex flex-col md:flex-row md:items-center">
            <div className="flex-grow">
              <a href="http://www.mbose.in/">
                <h3 className="text-xl font-bold text-blue-900 dark:text-white">
                  Higher Secondary School Education - HSSLC (Science)
                </h3>
                <div className="text-blue-700 dark:text-blue-400 text-1xl">
                  Course Type: <b>Full-time on Campus</b>
                </div>
                <div className="text-blue-700 dark:text-blue-400 text-1xl">
                  School:{" "}
                  <b>
                    St. Peters Higher Secondary School - Shillong, Meghalaya,
                    India. Pin code: 793003
                  </b>
                </div>
                <div className="text-blue-700 dark:text-blue-400 text-1xl">
                  Educational Board:{" "}
                  <b>Meghalaya Board of School Education</b>
                  <br />
                  Duration: <b>(2012-2014)</b>
                </div>
              </a>
            </div>
            <div className="flex-shrink-0">
              <a href="http://www.mbose.in/">
                <img
                  src="https://play-lh.googleusercontent.com/HcoMSyg-jWM3Fq_3O7lgRQuSGfWSFt8lpFCLZLA00smzUuKtOQz5_0zHEigncf57p54"
                  className="w-24 h-24 rounded-full"
                  alt="Higher Secondary School Education"
                />
              </a>
            </div>
          </li>
          <li className="bg-blue-300 rounded-lg p-4 hover:bg-blue-400 transition duration-300 flex flex-col md:flex-row md:items-center">
            <div className="flex-grow">
              <a href="http://www.mbose.in/">
                <h3 className="text-xl font-bold text-blue-900 dark:text-white">
                  Secondary-School Education - SSLC (Class-10th)
                </h3>
                <div className="text-blue-700 dark:text-blue-400 text-1xl">
                  Course Type: <b>Full-time on Campus</b>
                </div>
                <div className="text-blue-700 dark:text-blue-400 text-1xl">
                  School:{" "}
                  <b>
                    Shillong Boys Higher Secondary School - Shillong,
                    Meghalaya, India. Pin code: 793001
                  </b>
                </div>
                <div className="text-blue-700 dark:text-blue-400 text-1xl">
                  Educational Board:{" "}
                  <b>Meghalaya Board of School Education</b>
                </div>
              </a>
            </div>
            <div className="flex-shrink-0">
              <a href="http://www.mbose.in/">
                <img
                  src="https://play-lh.googleusercontent.com/HcoMSyg-jWM3Fq_3O7lgRQuSGfWSFt8lpFCLZLA00smzUuKtOQz5_0zHEigncf57p54"
                  className="w-24 h-24 rounded-full"
                  alt="Secondary-School Education"
                />
              </a>
            </div>
          </li>
        </ul>
      </section>
    </div>
  );
};

export default Navber3;
